import {IRootState} from "../reducers";

export const getToken = (state: IRootState) => state.authReducer.token;
export const getOrganizations = (state: IRootState) => state.authReducer.organizations;
export const getActiveOrganization = (state: IRootState) => state.authReducer.activeOrganization;
export const getCurrentUser = (state: IRootState) => state.authReducer.currentUser;
export const getOrgVersion = (state: IRootState) => state.authReducer.orgVersion;
export const getOrgSwitching = (state: IRootState) => state.authReducer.orgSwitching;
